import { createContext, useContext, useState, ReactNode } from 'react'
import { AlertModal } from '../components/AlertModal'

interface AlertContextType {
  showAlert: (message: string, type?: 'info' | 'warning' | 'error' | 'success', title?: string) => void
}

const AlertContext = createContext<AlertContextType | undefined>(undefined)

export function AlertProvider({ children }: { children: ReactNode }) {
  const [alertState, setAlertState] = useState<{
    isOpen: boolean
    message: string
    type: 'info' | 'warning' | 'error' | 'success'
    title?: string
  }>({
    isOpen: false,
    message: '',
    type: 'info'
  })

  const showAlert = (message: string, type: 'info' | 'warning' | 'error' | 'success' = 'info', title?: string) => {
    setAlertState({
      isOpen: true,
      message,
      type,
      title
    })
  }

  const closeAlert = () => {
    setAlertState(prev => ({ ...prev, isOpen: false }))
  }

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      <AlertModal
        isOpen={alertState.isOpen}
        message={alertState.message}
        type={alertState.type}
        title={alertState.title}
        onClose={closeAlert}
      />
    </AlertContext.Provider>
  )
}

export function useAlert() {
  const context = useContext(AlertContext)
  if (!context) {
    throw new Error('useAlert must be used within AlertProvider')
  }
  return context
}


